import { useEffect, useState } from 'react'
import { Trans, useTranslation } from 'react-i18next'

import eventEmitter, { types } from '../../shared/eventEmitter'
import useDialogDismiss from '../../shared/useDialogDismiss'
import { TRoutes } from '../../shared/const'
import Btn from '../Btn'

import styles from './style.module.scss'

/*
 * Hinweis auf die Anmeldung als Unterstützer:in nach dem Herunterladen der
 * Teilnahmeurkunde (Anforderung #212). Hängt einmal in App.js und wird über
 * `showSupporterInvitation` in shared/supporterInvitation geöffnet — dort steht
 * auch, wer ihn bekommt.
 *
 * Nur ein Hinweis: Klick daneben, Esc und „Schließen" schließen ihn; der
 * Download ist da längst angelaufen. Die Registrierung öffnet sich in einem
 * neuen Tab, damit die Anwendung stehen bleibt.
 */
export default function SupporterInvitationDialog() {
	const { t } = useTranslation()
	const [open, setOpen] = useState(false)

	useEffect(() => {
		const handleOpen = () => setOpen(true)
		eventEmitter.on(types.openSupporterInvitation, handleOpen)
		return () => eventEmitter.off(types.openSupporterInvitation, handleOpen)
	}, [])

	const close = () => setOpen(false)
	const backdropProps = useDialogDismiss(close, { enabled: open })

	if (!open) return null

	return (
		<div className={styles.backdrop} {...backdropProps}>
			<div className={styles.dialog} role="dialog" aria-modal="true" aria-labelledby="supporter-invitation-title">
				<h2 id="supporter-invitation-title" className={styles.title}>
					{t('Your journey continues')}
				</h2>
				<p className={styles.text}>
					<Trans
						i18nKey="SupporterInvitationText"
						components={{
							// Nicht „link" nennen: Das ist in HTML ein leeres Element,
							// der Text stünde dann hinter statt in dem Verweis.
							signup: (
								// Der Text kommt aus der Übersetzung (<signup>…</signup>).
								// eslint-disable-next-line jsx-a11y/anchor-has-content
								<a
									className={styles.link}
									href={TRoutes.SUPPORTER_REGISTER}
									target="_blank"
									rel="noopener noreferrer"
								/>
							)
						}}
					/>
				</p>
				<div className={styles.actions}>
					<Btn type="button" theme="primary" onClick={close}>
						{t('Close')}
					</Btn>
				</div>
			</div>
		</div>
	)
}
